import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function archiveServiceRequest(
  id: string,
  archiveReason: string
) {
  const response = await fetcher(
    `${API_BASE_PATH}/${id}/archive`,
    {
      method: 'POST',
      body: { archiveReason },
    },
    undefined
  );

  return response;
}
